import * as actionTypes from "../actionTypes/Index";
import { orderInitialState } from "./InitialState";
import { IActionType, IFetchOrderActionResponse } from "../../interfaces/Index";

const initialState = { ...orderInitialState };

export const appendUpdateOrders = (
  payload: IFetchOrderActionResponse,
  state: any
) => {
  if (payload.isPaginatedRes) {
    return [...state.orders, ...payload.ordersData];
  }
  return payload.ordersData.slice();
};

export default function ordersReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.GET_ORDERS_INIT: {
      return Object.assign({}, state, {
        isFetchOrderLoading: true,
        isFetchOrderError: false,
        isOrderCreated: false,
        isOrderUpdated: false,
        isOrderStatusUpdated: false,
        userCreditPlan: null,
        creditPaymentPlans: [],
        error: null,
        isError: false,
      });
    }
    case actionTypes.GET_ORDERS_SUCCESS: {
      return Object.assign({}, state, {
        isFetchOrderLoading: false,
        orders: appendUpdateOrders(action.payload as any, state),
        pagination: (action.payload! as any).pagination,
      });
    }
    case actionTypes.GET_ORDERS_FAIL: {
      return Object.assign({}, state, {
        isFetchOrderLoading: false,
        isFetchOrderError: true,
        error: action.error,
      });
    }
    case actionTypes.CREATE_ORDER_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isOrderCreated: false,
        error: null,
      });
    }
    case actionTypes.CREATE_ORDER_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isOrderCreated: true,
      });
    }
    case actionTypes.CREATE_ORDER_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isOrderCreated: false,
        error: action.error,
      });
    }
    case actionTypes.GET_ORDERS_DETAILS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        error: null,
        isOrderAdded: false,
        isOrderDetailsFetched: false,
        userCreditPlan: null,
        creditPaymentPlans: [],
        orderDetails: {},
        isOrderUpdated: false,
      });
    }
    case actionTypes.GET_ORDERS_DETAILS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isOrderDetailsFetched: true,
        orderDetails: action.payload,
      });
    }
    case actionTypes.GET_ORDERS_DETAILS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }
    case actionTypes.CLEAR_ORDER_DETAILS: {
      return Object.assign({}, state, {
        orderDetails: {},
        isOrderDetailsFetched: false,
        isError: false,
        error: null,
      });
    }
    case actionTypes.UPDATE_ORDER_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isOrderUpdated: false,
        error: null,
        isOrderCreated: false,
      });
    }
    case actionTypes.UPDATE_ORDER_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isOrderUpdated: true,
      });
    }
    case actionTypes.UPDATE_ORDER_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isOrderUpdated: false,
        error: action.error,
      });
    }
    case actionTypes.UPDATE_ORDER_STATUS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isError: false,
        isOrderUpdated: false,
        error: null,
        isOrderCreated: false,
        isOrderStatusUpdated: false,
      });
    }
    case actionTypes.UPDATE_ORDER_STATUS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isOrderStatusUpdated: true,
      });
    }
    case actionTypes.UPDATE_ORDER_STATUS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        isOrderStatusUpdated: false,
        error: action.error,
      });
    }
    case actionTypes.GET_PROMOS_FOR_ORDER_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        isPromosForOrderFetched: false,
        promosForOrder: null,
        error: null,
        isError: false,
      });
    }
    case actionTypes.GET_PROMOS_FOR_ORDER_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isPromosForOrderFetched: true,
        promosForOrder: action.payload,
      });
    }
    case actionTypes.GET_PROMOS_FOR_ORDER_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isPromosForOrderFetched: false,
        isError: true,
        error: action.error,
      });
    }

    case actionTypes.GET_ORDER_PRICE_BREAKDOWN_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        orderPriceBreakdown: null,
        isOrderPriceBreakdownFetched: false,
        error: null,
        isError: false,
      });
    }
    case actionTypes.GET_ORDER_PRICE_BREAKDOWN_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isOrderPriceBreakdownFetched: true,
        orderPriceBreakdown: action.payload,
      });
    }
    case actionTypes.GET_ORDER_PRICE_BREAKDOWN_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isOrderPriceBreakdownFetched: false,
        isError: true,
        error: action.error,
      });
    }
    case actionTypes.GET_USERS_CREDIT_LIMIT_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        userCreditPlan: null,
        error: null,
        isError: false,
      });
    }
    case actionTypes.GET_USERS_CREDIT_LIMIT_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        userCreditPlan: action.payload,
      });
    }
    case actionTypes.GET_USERS_CREDIT_LIMIT_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }
    case actionTypes.GET_CREDIT_PAYMENT_PLANS_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        creditPaymentPlans: [],
        error: null,
        isError: false,
      });
    }
    case actionTypes.GET_CREDIT_PAYMENT_PLANS_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        creditPaymentPlans: action.payload,
      });
    }
    case actionTypes.GET_CREDIT_PAYMENT_PLANS_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }
    case actionTypes.CLEAR_CREDIT_LIMIT_AND_PLANS: {
      return Object.assign({}, state, {
        userCreditPlan: null,
        creditPaymentPlans: [],
      });
    }
    case actionTypes.FETCH_CREDIT_USER_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
        isError: false,
      });
    }
    case actionTypes.FETCH_CREDIT_USER_SUCCESS: {
      const modifesObjecct = {
        ...state,
        isLoading:false,
        userCreditStatus: action.payload,
      };
      return modifesObjecct;
    }

    case actionTypes.FETCH_CREDIT_USER_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }
    default:
      return state;
  }
}
